import { get, post, request } from '@/api/request';

const URI = "/moneyOrder"


// 票据管理-汇票列表
export const unhandledTicket = (page, size, params) => post(`${URI}/selectMoneyOrderByStatus?page=${page}&size=${size}`, params);
// 票据管理-汇票概况
export const getTicketByCode = (params) => post(`${URI}/selectMoneyOrderByCode`, params);
export const updateClient = params => post(`${URI}/updateClient`, params);
// 票据管理-新增
export const addTicket = params => post(`${URI}/saveInorderByhand`, params);
// 票据管理-入库/出库列表
export const listTicket = (page, size, params) => post(`${URI}/selectMoneyOrder?page=${page}&size=${size}`, params);
// 票据管理-获取票据信息
export const getTicket = params => get(`${URI}/selectMoneyOrderById`, params);
// 票据管理-入库
export const storeTicket = params => post(`${URI}/updateMoneyOrder`, params);
// 票据管理-抓票批量修改
export const updateBatchCaptureTicket = params => post(`${URI}/updateMoneyOrderByInSalesmanList`, params);
// 票据管理-批量入库修改
export const updateBatchStoreTicket = params => post(`${URI}/updateMoneyOrderList`, params);
// 票据管理-批量出库修改
export const updateBatchDeliverTicket = params => post(`${URI}/updateOutMoneyOrderList`, params);
// 票据管理-入库待记账
export const waitpayForStoreTicket = params => post(`${URI}/updateMoneyOrderByPay`, params)
// 票据管理-出库
export const deliverTicket = params => post(`${URI}/updateOutMoneyOrder`, params);
// 票据管理-出库待记账
export const waitpayForDeliverTicket = params => post(`${URI}/updateOutMoneyOrderByPay`, params);
// 票据管理-删除票据
export const delTicket = id => get(`${URI}/deleteMoneyOrder/${id}`);
// 票据管理-批量删除票据
export const delBatchTicket = params => post(`${URI}/deleteMoneyOrderList`, params);
// 票据管理-业务员入库
export const storeTickBySalesman = params => post(`${URI}/updateMoneyOrderByInSalesman`, params);


// 票据管理-编辑拟售价
export const updatePresaleForTicket = params => post(`${URI}/updateMoneyOrderByPreSale`, params);
// 票据管理-批量编辑拟售价
export const updateBatchPresaleForTicket = params => post(`${URI}/updateMoneyOrderByPreSaleList`, params);
// 票据管理-查询预售价列表
export const listPresaleForTicket = (page, size, params) => post(`${URI}/selectMoneyOrderByPreSale?page=${page}&size=${size}`, params);


// 票据管理-线下入库列表
export const offlineStoreForTick = (page, size, params) => post(`${URI}/selectMoneyOrderByIsLine?page=${page}&size=${size}`, params);
// 票据管理-线下入库更新
export const offlineUpdateStoreForTick = params => post(`${URI}/updateMoneyOrderList`, params);
// 票据管理-线下票据批量删除
export const offlineDeleteBatchTicket = params => post(`${URI}/deleteMoneyOrderList`, params);

// 应付应收
export const listBill = (page, size, params) => post(`${URI}/selecReceivablePayableList?page=${page}&size=${size}`, params);
export const waitpayForBill = (params) => post(`${URI}/updateReceivablePayable`, params);
// 应付应收-导出
export const exportBill = (params = {}) => request({
    url: `${URI}/exportByPayableList`,
    method: 'post',
    responseType: 'blob',
    data: params
});

// 票据管理-修改
export const backTicket = params => post(`${URI}/backTicket`, params);



// 票据管理-对账流水
export const addReconcileStream = params => post(`/reconcile/saveOrUpdate`, params);
// 票据管理-对账流水
export const listReconcileStream = (page, size, params) => post(`/reconcile/lists?page=${page}&size=${size}`, params);
export const updateReceivables = params => post(`/reconcile/updateReceivables`, params);
// 应付应收-导出
export const uploadLoad = (params = {}) => request({
    url: `/upload/load`,
    method: 'post',
    data: params
});


// WEBPACK FOOTER //
// ./src/api/ticket/ticket.js